import React, { useEffect, useState } from "react";
import { Box, Typography, Button, TextField, Grid, Table, TableBody, TableCell, TableHead, TableRow, Paper, CircularProgress } from "@mui/material";
import ApiService from "../../functions/apiService";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import moment from "moment";

const GeneralRecall = () => {
  const { shiftDate, shiftNumber } = useParams();
  const [adminEmployeeList, setAdminEmployeeList] = useState([]);
  const [headerData, setHeaderData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const navigate = useNavigate();

  // console.log("recall===>10", adminEmployeeList, headerData)

  const fetchEmployeeList = async () => {
    try {
      // setLoading(true);

      const payload = {
        Shift_Date: shiftDate,
        Shift_Number: shiftNumber
      };

      // console.log("Payload:====>23", payload);

      const response = await ApiService.post(
        "/general-recall/admin-employee-list",
        payload
      );

      if (response.status) {
        setAdminEmployeeList(response.data);
      }

    } catch (err) {
      console.log("API Error:", err);
    } finally {
      setLoading(false);
    }
  };
  const fetchHeaderData = async () => {
    try {
      setLoading(true);

      const payload = {
        Shift_Date: shiftDate,
        Shift_Number: shiftNumber
      };

      // console.log("Payload:====>23", payload);

      const response = await ApiService.post(
        "/general-recall/data",
        payload
      );

      // console.log("response===>58",response)
      if (response.status) {
        setHeaderData(response?.data);
      }

    } catch (err) {
      console.log("API Error:", err);
    } finally {
      setLoading(false);
    }
  };


useEffect(() => {
  // run immediately once
  fetchEmployeeList();

  const intervalId = setInterval(() => {
    fetchEmployeeList();
  }, 4000); // 1 second

  return () => clearInterval(intervalId);
}, [shiftDate, shiftNumber]);

  useEffect(() => {
    if (!shiftDate || !shiftNumber) return;

    fetchHeaderData();
    // fetchEmployeeList();
  }, [shiftDate, shiftNumber]);


  // const handleSearch = async (text) => {
  //   try {
  //     const payload = {
  //       Shift_Date: shiftDate,
  //       Shift_Number: shiftNumber,
  //       page_type: "GR_Detail",
  //       page_text: text
  //     };

  //     const res = await ApiService.post("/general-recall/create", payload);
  //     if (res.status) {
  //       toast.success(res.message);
  //       setSearchText("");
  //       fetchHeaderData();


  //     }
  //     console.log("resp====>82", res, text)
  //   } catch (err) {
  //     console.log("Search API Error:", err);
  //   }
  // };
 
  const handleSearch = async (text) => {
  try {
    setLoading(true);

    const payload = {
      Shift_Date: shiftDate,
      Shift_Number: shiftNumber,
      page_type: "GR_Detail",
      page_text: text
    };

    const res = await ApiService.post("/general-recall/create", payload);

    if (res.status) {
      toast.success(res.message);
      setSearchText("");
      fetchHeaderData();
    }
  } catch (err) {
    console.log("Search API Error:", err);
  } finally {
    setLoading(false);
  }
};

  const handleBack = () => {
  navigate('/firehouse/recall/pages');
};
const handleRefresh = () => {
  window.location.reload();
};
if (loading) {
  return (
    <Box sx={{ display: "flex", justifyContent: "center", mt: 10 }}>
      <CircularProgress size={45} />
    </Box>
  );
}
const formatDateWithMoment = (dateString) => {
  if (!dateString) return "";
  return moment(dateString).format("MM/DD/YYYY ddd hh:mm A");
};



  return (
    <>
      {/* <Paper> */}
      <Box sx={{ m: 3, p: 3, bgcolor: "#fff", borderRadius: 2, boxShadow: 2 }}>
        {/* Header Section */}
        <Box
          sx={{
            p: 2,
            borderRadius: 2,
            backgroundColor: "#f9fafb",
            border: "1px solid #e0e0e0",
            mb: 3
          }}
        >
          <Grid container justifyContent="space-between" alignItems="center">
            <Typography variant="h5" sx={{ fontWeight: "bold" }}>
              General Recall
            </Typography>

            <Typography
              variant="subtitle1"
              sx={{
                color: headerData?.Status === "ACTIVE" ? "#2e7d32" : "#757575",
                fontWeight: "bold",
                backgroundColor: headerData?.Status === "ACTIVE" ? "#e8f5e9" : "#f5f5f5",
                px: 2,
                py: 0.5,
                borderRadius: "20px",
              }}
            >
              {headerData?.Status}
            </Typography>
          </Grid>

          <Box sx={{ mt: 2, mb: 1 }}>
            <Typography variant="body1" sx={{ color: "#424242" }}>
             {formatDateWithMoment(headerData?.Created_Date)}
            </Typography>
            <Typography variant="body1" sx={{ color: "#424242" }}>
              <b>Created By:</b> {headerData?.Created_By}
            </Typography>
          </Box>
        </Box>

        {/* Logs Section */}
        <Box
          sx={{
            p: 2,
            borderRadius: 2,
            backgroundColor: "#ffffff",
            border: "1px solid #e0e0e0",
            mb: 3
          }}
        >
          <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
            Activity Logs
          </Typography>

          {headerData?.logs?.length > 0 ? (
            headerData.logs.map((log, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  p: 1.5,
                  borderBottom: "1px solid #eee",
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: "bold",
                    minWidth: "120px",
                    color: "#616161"
                  }}
                >
                  {/* {log.time} */}
                  {formatDateWithMoment(log.time)}
                </Typography>

                <Typography variant="body2" sx={{ color: "#424242" ,marginLeft:'12px' }}>
                  {log.description}
                </Typography>
              </Box>
            ))
          ) : (
            <Typography variant="body2" color="text.secondary">No log history found.</Typography>
          )}
        </Box>


        {/* Search */}
        <Box mt={3} display="flex" gap={2} alignItems="center">
          <TextField
            fullWidth
            size="small"
            placeholder="Search..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
          <Button variant="outlined" onClick={() => handleSearch(searchText)}>
            Page
          </Button>
        </Box>



        {/* In Station */}
        <Box mt={4}>
          <Typography variant="h6" fontWeight="bold">
            In Station
          </Typography>
          <Paper sx={{ mt: 1 }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell><b>Name</b></TableCell>
                  <TableCell><b>Log Time</b></TableCell>
                  <TableCell><b>Station</b></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>

                {adminEmployeeList?.in_quarters?.length > 0 ? (
                  adminEmployeeList.in_quarters.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell>{item.Emp_Name}</TableCell>
                      <TableCell>{item.log_time}</TableCell>
                      <TableCell>{item.station}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={3} align="center">No records</TableCell>
                  </TableRow>
                )}

              </TableBody>
            </Table>
          </Paper>
        </Box>

        {/* En Route */}
        <Box mt={4}>
          <Typography variant="h6" fontWeight="bold">
            En Route
          </Typography>
          <Paper sx={{ mt: 1 }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell><b>Name</b></TableCell>
                  <TableCell><b>Log Time</b></TableCell>
                  <TableCell><b>ETA</b></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>

                {adminEmployeeList?.en_route?.length > 0 ? (
                  adminEmployeeList.en_route.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell>{item.Emp_Name}</TableCell>
                      <TableCell>{item.log_time}</TableCell>
                      <TableCell>{item.eta}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={3} align="center">No records</TableCell>
                  </TableRow>
                )}

              </TableBody>
            </Table>
          </Paper>
        </Box>

        {/* Buttons */}
        <Box mt={3} display="flex" gap={2}>
          <Button variant="outlined" onClick={handleRefresh}>Refresh</Button>
          <Button variant="outlined" onClick={handleBack}>Back</Button>
        </Box>
      </Box>
      {/* </Paper> */}
    </>

  );
};

export default GeneralRecall;
